import React, { useState } from 'react';

import DropdownWithSearch from "../../../SharedComponents/Forms/DropdownWithSearch";
import SvgIcon from "../../../SharedComponents/Icons";

import './index.sass';


const SearchAreaFilter = ({ generateBreadcrumbs,
                            regionsOptions,
                            setBreadcrumbs,
                            setCoords,
                            setPage,
                            setSelectedDistrict,
                            setSelectedRegion }) => {

  const [inputValue, setInputValue] = useState('');
  const [searchRegionsResults, setSearchRegionsResults] = useState([]);
  const [searchDistrictsResults, setSearchDistrictsResults] = useState([]);
  const [noSearchResults, setNoSearchResults] = useState(false);


  const handleSelect = (data, asRegion) => {
    const breadcrumbs = generateBreadcrumbs(asRegion ? data : data.region, asRegion ? null : data);
    const selectedDistrictSlug = !asRegion ? data.slug : null;
    const selectedRegionSlug = asRegion ? data.slug : null;

    setSelectedDistrict(selectedDistrictSlug);
    setSelectedRegion(selectedRegionSlug);
    setInputValue(data.name);
    setPage(1);
    setCoords({});
    setBreadcrumbs(breadcrumbs);
    pushState(`${!asRegion ? `/${data.region.slug}` : ''}/${data.slug}`, { selectedRegionSlug, selectedDistrictSlug }, breadcrumbs);
  };


  const pushState = (locationUrl, locationData, breadcrumbs) => {
    const state = { ...locationData, breadcrumbs };
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.has('page') && urlSearchParams.delete('page');

    const searchParamsString = urlSearchParams.toString();
    const url = `/leje${locationUrl}${searchParamsString ? `?${searchParamsString}` : ''}`;
    const sameUrl = window.location.pathname + window.location.search === url;

    setInputValue('');
    !sameUrl && history.pushState(state, '', url);
  };


  const handleSearchInput = (value) => {
    setInputValue(value);

    const clearString = (string) => string.replace(/[^a-z\d\s]+/gi, "").toLowerCase();
    const searchByFirstLetter = value.length === 1;
    const query = clearString(value);
    let foundRegions = [];
    let foundDistricts = [];

    if (query) {

      regionsOptions.map(region => {
        const { districts, name, slug } = region;

        if (searchByFirstLetter) {
          (slug.split('')[0].toLowerCase() === query || name.split('')[0].toLowerCase() === query)
          && foundRegions.push(region);

          districts.map(district => {
            const hasDistrictPostalCode = district.postalCodes.find(postalCode => value.includes(postalCode));

            (district.name.split('')[0].toLowerCase() === query || district.slug.split('')[0].toLowerCase() === query || hasDistrictPostalCode)
            && foundDistricts.push({ ...district, region });
          }

          );
        } else {
          (clearString(slug).includes(query) || clearString(name).includes(query))
          && foundRegions.push(region);

          districts.map(district => {
            const hasDistrictPostalCode = district.postalCodes.find(postalCode => value.includes(postalCode));

            (clearString(district.slug).includes(query) || clearString(district.name).includes(query) || hasDistrictPostalCode)
            && foundDistricts.push({ ...district, region });
          });
        }
      });

      foundRegions.sort((a, b) => b.placesCount - a.placesCount);
      foundDistricts.sort((a, b) => b.placesCount - a.placesCount);
      setSearchRegionsResults(foundRegions.slice(0, 5));
      setSearchDistrictsResults(foundDistricts.slice(0, 5));
    } else {
      setSearchRegionsResults([]);
      setSearchDistrictsResults([]);
    }

    setNoSearchResults(value && (!foundRegions.length && !foundDistricts.length));
  };


  const searchResultsComponent =
    <div className="search-area__search-results">
      { !!searchRegionsResults.length &&
        <div className={`search-area__search-results-list ${searchDistrictsResults.length ? 'with-border' : ''}`}>
          <div className="search-area__search-results-list-headline">
            LANDSDELE
          </div>
          { searchRegionsResults.map(region =>
            <div className="search-area__search-results-list-item dropdown__option" onClick={() => handleSelect(region, true)} key={region.id}>
              <div className="search-area__search-results-item-label">
                { region.name }
              </div>
              <div className="search-area__search-results-item-count">
                { region.placesCount } stk.
              </div>
            </div>
          )}
        </div>
      }
      { !!searchDistrictsResults.length &&
        <div className="search-area__search-results-list regions">
          <div className="search-area__search-results-list-headline">
            OMRÅDER
          </div>
          { searchDistrictsResults.map(district =>
            <div className="search-area__search-results-list-item dropdown__option" onClick={() => handleSelect(district)} key={district.id}>
              <div className="search-area__search-results-item-label district">
                { district.slug.split('-').join(' ') }
              </div>
              <div className="search-area__search-results-item-count">
                { district.placesCount } stk.
              </div>
            </div>
          )}
        </div>
      }
      { noSearchResults &&
        <div className="dropdown__no-results">
          Din søgning giver desværre ingen resultater. Prøv eventuelt at søge på et postnummer eller en landsdel.
        </div>
      }
    </div>;

  const showSearchResults = !!(noSearchResults || searchRegionsResults.length || searchDistrictsResults.length);

  return (
    <DropdownWithSearch
      handleSelect={(region) => handleSelect(region, true)}
      handleSearch={(value) => handleSearchInput(value)}
      inputValue={inputValue}
      options={regionsOptions}
      placeholder={'Postnummer eller By'}
      searchIcon={<SvgIcon name="map_pin" size={16} />}
      searchResultsComponent={searchResultsComponent}
      showSearchResults={showSearchResults}
    />
  )
}

export default SearchAreaFilter;
